import { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react';
import { message } from 'antd';
import { useDesktop, useMenu, useThirdApp, useLayout } from '@/store';
import FormCommon, { FormCommonInstance } from '@/components/FormCommon';
import { CheckboxItem, SelectItem } from '@/components/FormItem';
import ThridApp from './ThirdApp';
import Layoutbox, { LayoutBoxRef } from './LayoutBox';
import createThridApp from './LayoutBox/layoutItems/createThirdApp';
import { $fm, $t } from '@/Intl';
import { getArea } from './LayoutBox/doWithSider';

export default observer(() => {
  const formRef = useRef<FormCommonInstance>(null);
  const layoutBoxRef = useRef<LayoutBoxRef>(null);
  const [n, remountLayout] = useState(0);
  const [desktop, updateDesktop, deskDefaults] = useDesktop();
  const [, updateMenu, menuDefaults] = useMenu();
  const [, updateLayout, layoutDefaults] = useLayout();
  const [, setTmpApps] = useThirdApp();

  useEffect(() => {
    const { desktopNum, appPreScreen } = desktop;
    if (appPreScreen && desktopNum && appPreScreen > desktopNum - 1) {
      formRef.current?.updateValue({
        appPreScreen: desktopNum - 1,
      });
    }
  }, [desktop]);

  return (
    <FormCommon
      initialValues={desktop}
      onUpdate={updateDesktop}
      defaults={deskDefaults}
      ref={formRef}
      onReset={() => {
        updateMenu(menuDefaults);
        updateLayout(layoutDefaults);
        setTmpApps([]);
        remountLayout(n + 1);
      }}
    >
      <Layoutbox key={n} ref={layoutBoxRef} />
      <br />
      <CheckboxItem label={$fm('DIALPAD_SHOW')} name='keepCustomScreen' />
      <CheckboxItem label={$fm('DIA_DESK_MANAGE')} name='disableDestManage' />
      <CheckboxItem label={$fm('DIA_DESK_BTN')} name='disableTouchBtns' />
      <CheckboxItem
        label={$fm('DIS_REMOVE_WIDGET')}
        name='disableRemoveWidget'
      />
      <CheckboxItem label={$fm('DISABLE_FOCUS_MODE')} name='disableFocusMode' />
      <SelectItem
        label={$fm('APP_INSTALL_SCREEN')}
        name='appPreScreen'
        options={Array(desktop.desktopNum || 4)
          .fill(' ')
          .map((_, i) => ({
            t: i + 1,
            v: i,
          }))}
      />
      <ThridApp
        canUploadThirdApp={() => {
          const GB = layoutBoxRef.current?.GB.current;
          const avaliable = GB?.getEmptyPosition({
            id: '-1',
            w: 1,
            h: 1,
            area: getArea(layoutBoxRef.current!.siderBounds),
          });
          if (avaliable) {
            return true;
          } else {
            message.error($t('NOSPACE_WARN'));
            return false;
          }
        }}
        afterUpload={(app) => {
          if (!app.className) return;
          const GB = layoutBoxRef.current?.GB.current;
          GB?.insertItem(
            createThridApp(
              {
                className: app.className,
                title: app.displayName,
              },
              layoutBoxRef.current!.siderBounds,
            ),
          );
        }}
      />
    </FormCommon>
  );
});
